//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebClient.GPodUtils.ts                           </Name>
//    <Description>                                                             </Description>
//    <Author>      Šebesta David                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2018                            </Copyright>
//    <Created>     2018-07-27                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.Utils {

    let Srv: GContent = null;

    export function GetSrv(): GContent {
        if (Srv == null) {
            Srv = new GContent({ className: "Gordic.Pod.WebControls.GPodUtils", params: {} });
        }
        return Srv;
    }



    //#region el podaní
    //Tatofunkce je Upravena Rro LK
    export function VytvorSouborPotvrzeni(content: GContent, dto: WebControls.GEvidenceElPodaniVytvoritSouborPodaniDto): JQuery.Promise<WebControls.GEvidenceElPodaniVytvoritSouborPodaniDto> {
        let hlavniPromis = $.Deferred<WebControls.GEvidenceElPodaniVytvoritSouborPodaniDto>();
        var srv = GetSrv();
       
        var beforeSelectCertDelegate = (customDto) => { return $.Deferred().resolve({}).promise(); }
        content.log.trace("TS VytvorSouborPotvrzeni - před zavoláním VytvorSouborPotvrzeni");
        srv.call<Pod.WebControls.GEvidenceElPodaniVytvorSouborPotvrzeni>("VytvorSouborPotvrzeni", { textOdpovedi: dto.TextPotvrz }).done(function (VytvorSouborPotvrzeniDto) { // vytvořím soubor potvrzeni
            dto.TypSouboruPotvrzeni = VytvorSouborPotvrzeniDto.SouborPovrzeniPathExtension; //"pdf"
            //var fileContent = dto.TextPotvrz; // nevím zda je aktualní
            content.log.trace("TS VytvorSouborPotvrzeni -  done vytvoření potvrzení");
            OtazkaZdaPodepsatSouborPotvrzeni(content, dto).done(function (podepsat) { // dotaz zda se má podepsat
                content.log.trace("TS VytvorSouborPotvrzeni -  podepsat: " + podepsat);
                if (podepsat) {
                    dto.IsPotvrzSignedFinal = true;
                    var fileName = VytvorSouborPotvrzeniDto.NazevSouboru;
                    
                    //if ((content as any).localGsgn == null) {
                    (content as any).localGsgn = new Gordic.Wfl.WebClient.GByteSigner();
                        // ######################  Duležitá ukázka jak ovlivnit výběr certifikátu.
                        /*
                        var a = new Gordic.Wfl.WebClient.GByteSigner(undefined, (CustomData) => {
                            var cerChain = a.selectWflCertificate({ title: "" }); // vratí se mi promisa s certifikatem. Ten pak uložím do usersettingu a přístě a když bude vyplněnej, tak nic neotvírám a rovnou vracím D.
                            // když nechci aby delegat fungoval vracímn undefined
                            return $.Deferred<CertInfo, IGReasonResponse>().resolve().promise();
                        });
                        a.sign({
                            signWithTimeStamp: true,
                        }, {title:});
                        */
                    //}
                    dto.ObsahSouboruGUID = VytvorSouborPotvrzeniDto.ObsahSouboruGUID;
                    (content as any).localGsgn.sign
                        ({
                            file: VytvorSouborPotvrzeniDto.ObsahSouboruGUID,
                            fileName: fileName,
                            signTime: new Date(),
                            idSigningReason: dto.IxsDpo,
                        }, { title:"jres:31950288"}) //RC 31950288 : Výběr certifikátu pro podpis souboru porvrzení
                        .then((signedConfig: Gordic.Wfl.WebClient.GSignatureResultDtoWithGuids) => {
                            content.log.trace("TS VytvorSouborPotvrzeni -  před voláním Ulož soubor ");
                            return srv.call<boolean>("UlozSoubor", { signatureResult: signedConfig, vytvorSouborPotvrzeniDto: VytvorSouborPotvrzeniDto });
                        }, (reason: any) => { //fail
                            Gordic.Gui.WebApp.Utils.showReasonFlash(content, reason);
                            hlavniPromis.reject(reason);
                            if (!reason.handled) {
                                content.showFlash(reason.reason, "error");
                            }
                        }
                    ).then((SouborUlozen) => {
                        content.log.trace("TS VytvorSouborPotvrzeni -  SouborUlozen: " + SouborUlozen);
                            if (SouborUlozen) {
                                VytvorZpravuPotvrzeni(content, dto, hlavniPromis);
                            }

                        });

                } else {
                    VytvorZpravuPotvrzeni(content, dto, hlavniPromis);
                }
            });

        });
       

        return hlavniPromis;
    }

    //Tatofunkce je Upravena Rro LK
    /**
     * funkce pro dotaz zda se má podepsat soubor
     * @param {GContent} content
     * @param {WebControls.GEvidenceElPodaniVytvoritSouborPodaniDto} dto
     * @returns
     */
    function OtazkaZdaPodepsatSouborPotvrzeni(content: GContent, dto: WebControls.GEvidenceElPodaniVytvoritSouborPodaniDto): JQuery.Promise<boolean> {

        let promis = $.Deferred<boolean>();
        switch (dto.IsPotvrzSigned) {
            case "1":
                promis.resolve(true);
                break;
            case "2":
                content.dialogs.confirm("Dotaz", "jres:31950281").on("close", function (ev, retVal) { //RC 31950281 : Podepsat soubor potvrzení?
                    if (retVal === "yes") {
                        promis.resolve(true);
                    } else {
                        promis.resolve(false);
                    }
                });
                break;
            default:
                promis.resolve(false);

        }
        return promis.promise();

    }


    //Tatofunkce je Upravena Rro LK
    //vytvoreni zpravy potvrzeni
    function VytvorZpravuPotvrzeni(content: GContent, dto: WebControls.GEvidenceElPodaniVytvoritSouborPodaniDto, hlavniPromis: JQuery.Deferred<WebControls.GEvidenceElPodaniVytvoritSouborPodaniDto>) {
        var srv = GetSrv();
        content.log.trace("TS VytvorZpravuPotvrzeni -  SouborUlozen: start");
        srv.call<WebControls.GEvidenceElPodaniVytvorZpravuPotvrzeni>("VytvorZpravuPotvrzeni", { textOdpovedi: dto.TextPotvrz }).done(function (retVal) { // vytvořím soubor potvrzeni
            content.log.trace("TS VytvorZpravuPotvrzeni -  SouborUlozen: done" );
            if (retVal) {
                dto.TextZpravy = retVal.ZpravaPotvrzeni; // puvodně se nevracel
                dto.ZpravaPotvrzeniGUID = retVal.ZpravaPotvrzeniGUID;
                dto.NazevSouboru = retVal.NazevSouboru;
                PodepisMailNeboOdesli(content, dto, hlavniPromis);
                
            }

        });

    }

    function PodepisMailNeboOdesli(content: GContent, dto: WebControls.GEvidenceElPodaniVytvoritSouborPodaniDto, hlavniPromis: JQuery.Deferred<WebControls.GEvidenceElPodaniVytvoritSouborPodaniDto>) {
        if (dto.EmailCbx && dto.EmailSignCbx) {
            content.log.trace("TS PodepisMailNeboOdesli -  odeslání s podpisem");
            PodepisMail(content, dto, hlavniPromis);
        }
        else {
            dto.LzeVolatOeslatPozvrzeni = true;
            content.log.trace("TS PodepisMailNeboOdesli -  odeslání bez podpisu");
            hlavniPromis.resolve(dto);
            //GinisEvent('OdeslatPotvrzeni');
        }
    }

    function PodepisMail(content: GContent, dto: WebControls.GEvidenceElPodaniVytvoritSouborPodaniDto, hlavniPromis: JQuery.Deferred<WebControls.GEvidenceElPodaniVytvoritSouborPodaniDto>) {
       

        //if ((content as any).localGsgn == null) {
            (content as any).localGsgn = new Gordic.Wfl.WebClient.GByteSigner();
        //}
        content.log.trace("TS PodepisMail -  satart");
        (content as any).localGsgn.sign
            ({
                file: dto.ZpravaPotvrzeniGUID,
                fileName: dto.NazevSouboru,
                signTime: new Date(),
                //idSigningReason: dto.IxsDpo // na mail se nepoužívá
                //saveOnClient: false
            }, { title: "jres:31950289" }) //RC 31950289 : Výběr certifikátu pro podpis odpovědi
            .then((signedConfig) => {
                content.log.trace("TS PodepisMail -  podepsano");
                dto.LzeVolatOeslatPozvrzeni = true;
                dto.PodpisMailu = signedConfig;
                hlavniPromis.resolve(dto);
                return; 
            }, (reason: any) => { //fail
                Gordic.Gui.WebApp.Utils.showReasonFlash(content, reason);
                if (!reason.handled) {
                    content.showFlash(reason.reason, "error");
                }
                hlavniPromis.reject(reason);
            });
    }

    //#endregion



    //#region otevření podaní cizího dokumentu
       /*
    //------------------------------------------------------------------
    /// <summary> </summary>
    /// <param name="content"></param>
    /// <param name="_pokracuj"></param>
    /// <param name="_automat"></param>
    /// <param name="_dataPosty"></param>
    /// <param name="_refreshDataDelegate"></param>
    
    export function NoveCiziPodaniOpenTab(content:GContent, _pokracuj: boolean, _automat: boolean, _dataPosty: Gordic.Wfl.Interface.GWflvpdaDto, _refreshDataDelegate: JQueryPromise<any>): boolean{
        try {
            var _konec:boolean = false;    // ALF 4.9.2014 zda je ukončeno pomocí cancel 
            _pokracuj = false;
            var l_oIxp = "";
            var l_typPid = Gordic.Wfl.Interface.TypPid.neurceno;
            var  _editovatExistujici:boolean = null;
            var l_bPodani:boolean = true;
            if (!_automat) {

                var options = {
                    TypDok: Gordic.Wfl.Globals.Enums.TypDok.Cizi,
                    TypId: Gordic.Wfl.Globals.Enums.TypId.IXP
                };
                Gordic.Wfl.Dialogs.GenerovaniIxp(null, options, Gordic.Global.Enums.ModOtevreni.showModalWindow).done(function (rv: { Ixp: string, IxpExist: boolean }) {
                    if (rv) {


                    }
                });

                l_oIxp = GWflCommon.GetNewPidForPodani(true, out l_typPid, out _editovatExistujici);
                if (!l_oIxp.IsNullOrEmpty && l_typPid == TypPid.jizEvidovanyDokSpis && _editovatExistujici.IsNull) {
                    var l_oGDetWflspid = new GDetWflspid(GUserProcess.Current);

                    l_oGDetWflspid.ReadDbDataBezKontrolyOpravneni(l_oIxp);
                    var l_oGPodDokument = new GPodDokument(GUserProcess.Current);
                    bool l_bJeMoje = l_oGPodDokument.JePisemnostPodanaAVlastnimJi(l_oIxp, GUserProcess.Current.SessionInfo.IxsSu);
                    if (l_bJeMoje) {
                        // písemnost je podána a vlastním ji
                        l_bPodani = true;
                        GMessageBox.ShowInformation(GResources.GetResourceText(23900326)); //  23900326 : Dokument s tímto identifikátorem byl již podán, přepínám Vás do režimu Oprava dokumentu.
                    }
                    else {
                        l_bJeMoje = l_oGPodDokument.JePisemnostPodanaAPridelena(l_oIxp, GUserProcess.Current.SessionInfo.IxsSu);
                        if (l_bJeMoje) {
                            // písemnost je podána a je přidělena
                            l_bPodani = true;
                            GMessageBox.ShowInformation(GResources.GetResourceText(23900326)); //  23900326 : Dokument s tímto identifikátorem byl již podán, přepínám Vás do režimu Oprava dokumentu.
                        }
                    }
                    if (l_bJeMoje) {
                        // písemnost je podána a vlastním ji - start rezimu oprav a nacteni znamych udaju
                        Gordic.Wfl.Client.GDetWflstop l_oGDetWflstop = new GDetWflstop(GUserProcess.Current);
                        if (l_oGDetWflstop.ExistujeZaznamVWflstop(l_oIxp)) {
                            l_oGDetWflstop.ReadDbData(l_oIxp);
                        }
                    }
                    else {
                        var l_oGGinsfun = new GGinsfun(GUserProcess.Current);
                        GString l_oNazevRef = new GString("");
                        GString l_oNazevFun = new GString("");
                        GString l_oNazevSU = new GString("");
                        GString l_oIxsSu = new GString("");
                        GUserProcess.Current.Log.Write("NoveCiziPodaniOpenTab", "NoveCiziPodaniOpenTab 23920353 l_oGDetWflspid.IxsFunAkt: " + l_oGDetWflspid.IxsFunAkt);

                        if (l_oGGinsfun.ExistujeFunkce(l_oGDetWflspid.IxsFunAkt)) {
                            l_oGGinsfun.ReadGinsfunDetail(l_oGDetWflspid.IxsFunAkt);
                            l_oNazevRef = l_oGGinsfun.NazevRef.Trim();
                            l_oNazevFun = l_oGGinsfun.Nazev.Trim();
                            l_oNazevSU = l_oGGinsfun.NazevSu.Trim();
                            l_oIxsSu = l_oGGinsfun.IxsSu.Trim();
                            GUserProcess.Current.Log.Write("NoveCiziPodaniOpenTab", "NoveCiziPodaniOpenTab 23920354 l_oNazevRef: " + l_oNazevRef);
                        }
                        var l_oGDetSslspid = new GDetSslspid(GUserProcess.Current);
                        if (l_oGDetSslspid.ExistIxp(l_oIxp)) {
                            l_oGDetSslspid.ReadDbDataBezKontrolyOpravneni(l_oIxp);
                            if (l_oGDetSslspid.SOdes == 1) {
                                string l_Dotaz = GResources.GetResourceText(23900196) + " " + l_oNazevSU + ", " + l_oNazevFun + ", " + l_oNazevRef  //  23900196 : Probíhá příprava odeslání
                                    + Environment.NewLine + GResources.GetResourceText(23900197) //  23900197 : Předchozí
                                    + Environment.NewLine + GResources.GetResourceText(23900198); //  23900198 : Následující
                                l_bPodani = false;
                                var l_DialogResult = GMessageBox.Show(l_Dotaz, GResources.GetResourceText(23900008), GMessageBoxButtons.YesNoCancel, GMessageBoxIcon.Question); //  23900008 : podepsané
                                switch (l_DialogResult) {
                                    case DialogResult.Yes:
                                    case DialogResult.No:
                                        l_oGDetSslspid.ZnovupodaniDokumentu(new GString(""), new GString(""), new GString(""));
                                        if (l_DialogResult == DialogResult.Yes) {
                                            GPrideleniDokumentu.PridelitDokumenty(new GString[] { l_oIxp }, null, false, GUserProcess.Current);
                                        }
                                        break;
                                    default:
                                        l_oIxp = GString.Null;  // Cancel
                                        break;
                                }
                            }
                            else {
                                l_oGDetSslspid.ReadDbData(l_oIxp);
                                string l_sHlaska = string.Empty;
                                if (l_oGDetWflspid.TypAg == 20 || l_oGDetWflspid.TypAg == 190 || l_oGDetWflspid.TypAg == 200) {
                                    // je součástí jiného SU
                                    if (l_oIxsSu == GUserProcess.Current.SessionInfo.IxsSu.Trim()) {
                                        if (l_oGDetWflspid.SPrij == 1) {
                                            bool l_bEditVRedistr = GUserProcess.Current.Configuration.GetDatabaseParameter("ssl_rad_editred", 0) == 1;

                                            //2.3.2015 param se po dohode s L.Kosem ignoruje
                                            l_bEditVRedistr = true;

                                            if (!((l_oGDetWflspid.StavDist == 0 || l_oGDetWflspid.StavDist == 30 || l_bEditVRedistr) &&
                                                l_oGDetWflspid.SUloz == 0 &&
                                                (l_oGDetWflspid.StavPis == 0 || l_oGDetWflspid.StavPis == 10 || l_oGDetWflspid.StavPis == 20))) {

                                                GUserProcess.Current.Log.Write("NoveCiziPodaniOpenTab", "NoveCiziPodaniOpenTab 23920351 l_bEditVRedistr: " + l_bEditVRedistr.ToString() + ", l_oGDetWflspid.StavDist: " + l_oGDetWflspid.StavDist.ToString() + ", l_oGDetWflspid.StavPis: " + l_oGDetWflspid.StavPis.ToString() + ", l_oGDetWflspid.SUloz: " + l_oGDetWflspid.SUloz.ToString());
                                                GMessageBox.ShowWarning(GResources.GetResourceText(23900199)); //  23900199 : Dokument s tímto identifikátorem je ve stavu, který nedovoluje jeho editaci.
                                                l_bPodani = false;
                                            }
                                            else {
                                                GMessageBox.ShowWarning(GResources.GetResourceText(23900192)); //  23900192 : Dokument s tímto identifikátorem byla již podána, přepínám Vás do režimu Oprava dokumentu.
                                                l_bPodani = true;
                                            }
                                        }
                                        else {
                                            GMessageBox.ShowWarning(GResources.GetResourceText(23900200)); //  23900200 : Zadaný dokument je vlastní (nepatří do došlé pošty) a nelze tedy editovat informace o doručení.
                                            l_bPodani = false;
                                        }
                                    }
                                    else {
                                        GWflCommon.ShowWarning(GResources.GetResourceText(23900201) + Environment.NewLine + GResources.GetResourceText(23900202) + " " + l_oNazevSU + "," + l_oNazevFun + "," + l_oNazevRef + "."); //  23900202 : Aktuálním vlastníkem je
                                        l_bPodani = false;
                                    }
                                }
                                else {
                                    l_bPodani = false;
                                    if (l_oGDetWflspid.TypAg != 20 && l_oGDetWflspid.TypAg != 190 && l_oGDetWflspid.TypAg != 200) {
                                        l_sHlaska = GResources.GetResourceText(23900203) + " - " + l_oGDetWflspid.TypAgTxt.ToString() + Environment.NewLine + GResources.GetResourceText(23900202) + " " + l_oNazevSU + "," + l_oNazevFun + "," + l_oNazevRef + ".";    //  23900202 : Aktuálním vlastníkem je
                                    }
                                    else {
                                        if (new GWflsixp(GUserProcess.Current).ExistIxp(l_oIxp)) {
                                            if (l_oGPodDokument.JeIxpVeWflspidxx(l_oIxp)) {
                                                l_sHlaska = GResources.GetResourceText(23900204) + Environment.NewLine + GResources.GetResourceText(23900205);    //  23900205 : Pokud chcete více informací zobrazte si detail dokumentu či spisu pomocí vyhledání dokumentu či spisu dle identifikace.
                                            }
                                            else {
                                                l_sHlaska = GResources.GetResourceText(23900206); //  23900206 : Zadaný identifikátor byl již použit.
                                            }
                                        }
                                    }
                                    l_bPodani = false;
                                    GMessageBox.ShowWarning(l_sHlaska);
                                }
                            }
                        }
                    }
                }
            }
            if (!l_oIxp.IsNullOrEmpty || _automat) {
                if (l_bPodani) {
                    ModFormuPodaniEnum l_typPodani = ModFormuPodaniEnum.NovePodani;
                    if (_automat) l_typPodani = ModFormuPodaniEnum.NovePodaniAutomat;
                    if (l_typPid == TypPid.jizEvidovanyDokSpis) l_typPodani = ModFormuPodaniEnum.OpravaPodani;

                    var l_oTab = new GPodaniOpravaPisemnostiTab(l_oIxp, l_typPodani, GString.Null, l_typPid, _dataPosty, _refreshDataDelegate);

                    l_oTab.Closed += delegate
                    {
                        try {
                            if (l_oTab.TabResult == TabResultEnum.Ok) {
                                if (!l_oTab.Ixp.IsNullOrEmpty) {
                                    l_oIxp = l_oTab.Ixp;
                                }
                            }
                            else {
                                _konec = true;
                                if (_dataPosty != null) {
                                    GPodCommon.UpdateStavDavkyPosty(_dataPosty, WflcpzpEnum.nezpracovano);
                                }
                                _refreshDataDelegate?.Invoke();
                            }
                        }//end try
                        catch (GException exc) { GWflCommon.ResolveException(exc); }
                            catch (Exception exc) { throw new GException(23920301, 23900006, exc); }  // -EX 23900006 : Došlo k neočekávané výjimce.
                    };

                    GWflCommon.ShowTab(l_oTab, _task, Properties.Resources.Icons__Wfl__dokument_cizi_novy);
                }
                _pokracuj = (!l_oIxp.IsNullOrWhiteSpace && !_konec);
            }
        }
        catch (GException) { throw; }
            catch (Exception exc) {
            throw new GException(23920300, 23900006, exc);
        } // -EX 23900006 : Došlo k neočekávané výjimce.
    }

    
    */


    //#endregion


    export function NoveCiziPodani(content: GContent, automat: boolean, DataPosty: Wfl.Interface.GWflvpdaDto) {
        //debu
        var mainDto: WebControls.GNoveCiziPodaniRetDto = {};
        if (!automat) {

            Gordic.Wfl.Utils.GetNewPidForPodani({ content: content, multipid: true })
                .then(function (pidRetVal) {
                    //debu
                    if (pidRetVal && pidRetVal.Ixp) { 
                        //debu
                        mainDto.Ixp = pidRetVal.Ixp;

                        // InterniVypraveni
                        if (JdeOZasilkuInternihoVypraveni(content, pidRetVal.ListZasilekDto)) {
                            mainDto.Ixp = null;
                        }
                        else if (mainDto.Ixp != null && pidRetVal.TypPid == Wfl.Interface.TypPid.jizEvidovanyDokSpis && (pidRetVal.EditovatExistujici == null || pidRetVal.EditovatExistujici === false)) {
                            var srv = GetSrv();
                            srv.call<WebControls.PodaniNovehoCizihoUtilsDto>("PodaniNovehoCizihoUtils", { inputDto: { Ixp: mainDto.Ixp } })
                                .then(function (retValPNCU) {
                                    //debu
                                    VyhodInformaceHlasku(content, retValPNCU.DokumentSidentifikatoremJizPodanHlaska)
                                        .then(function () {
                                            //debu
                                            VyhodnotOtazkuKdyzJe(content, retValPNCU.OtazkaInterniVypraveni)
                                                .then(function (odpovedOtazkaInterniVypraveni) {
                                                    //debu
                                                    if (odpovedOtazkaInterniVypraveni === "yes") {
                                                        JdeOZasilkuInternihoVypraveni(content, retValPNCU.ZasilkaDto);
                                                    } else {
                                                        srv.call<WebControls.PodaniNovehoCizihoUtilsDto>("PodaniNovehoCizihoUtils2", { inputDto: retValPNCU })
                                                            .then(function (retValPNCU2) {
                                                                if (retValPNCU2.NovePodaniAPrideleniTohotoDokumentuOtazka) {
                                                                    VyhodnotOtazkuKdyzJe(content, retValPNCU2.NovePodaniAPrideleniTohotoDokumentuOtazka)
                                                                        .then((retVal) => {
                                                                            if (retVal !== 'yes') {
                                                                                // nedelam asi nic
                                                                            } else {
                                                                                //PredaniPrideleniDlg
                                                                                //GPrideleniDokumentu.PridelitDokumenty(new GString[] { l_oIxp }, null, false, UserProcess);// ############# TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!! 
                                                                            }

                                                                        });

                                                                } else {
                                                                    VyhodInformaceHlasku(content, retValPNCU2.NovePodaniAPrideleniKontroloaStavuHlaska1)
                                                                        .then(function () {
                                                                            NoveCiziPodaniFinal(content, automat, retValPNCU2.Ixp, retValPNCU2.Podani, pidRetVal.TypPid, DataPosty);
                                                                        });

                                                                }
                                                            });
                                                    }

                                                });
                                      
                                        });
                                });
                        } else if (mainDto.Ixp != null) {
                            //debu
                            NoveCiziPodaniFinal(content, automat, mainDto.Ixp, true, pidRetVal.TypPid, DataPosty);
                        } else {
                            content.log.trace("GPODUtils - NoveCiziPodani: KDyž to dojde sem tak trabl.  ");
                        }
                    }
                });
        } else {
            Gordic.Wfl.Utils.GetNewPidForPodani({ content: content, multipid: true })
                .then(function (pidRetVal) {
                    //debu
                    if (pidRetVal && pidRetVal.Ixp) {
                       /* // dsebesta nezahrnuto dokodu myslím že je to zbytečné zatím, že by to měla řešit nasledujici funkce NoveCiziPodaniFinal.
                        if (pidRetVal.TypPid !== undefined) { 
                            switch (pidRetVal.TypPid) {
                                case Wfl.Interface.TypPid.jizEvidovanyDokSpis:
                                    if (pidRetVal.EditovatExistujici) {
                                        ModFormuProp = ModFormuPodaniEnum.OpravaPodani;
                                        l_bReLoad = true;
                                    }
                                    else {
                                        if (l_editovatExistujici.IsNull) {
                                            GMessageBox.ShowInformation(GResources.GetResourceText(23900325)); //RC 23900325 : Zadejte tento PID ještě jednou.
                                        }
                                        Close();
                                    }
                                    break;

                                case Wfl.Interface.TypPid.funkce:
                                case Wfl.Interface.TypPid.referent:
                                case Wfl.Interface.TypPid.spisovyUzel:
                                    l_bReLoad = true;
                                    break;
                                default: l_bReLoad = false; break;
                            }   
                        }
                        */
                        NoveCiziPodaniFinal(content, automat, pidRetVal.Ixp, true, pidRetVal.TypPid, DataPosty);
                    }
                });

        }
    }

    export function NoveCiziPodaniFinal(content: GContent, automat: boolean, Ixp: string, Podani: boolean, TypPid: Gordic.Wfl.Interface.TypPid, DataPosty: Wfl.Interface.GWflvpdaDto) {
        if (Ixp != null || automat) {
            if (Podani) {
                var typPodani: Interface.ModFormuPodaniEnum = Interface.ModFormuPodaniEnum.NovePodani;
                if (automat) {
                    typPodani = Interface.ModFormuPodaniEnum.NovePodaniAutomat;
                }
                if (TypPid == Gordic.Wfl.Interface.TypPid.jizEvidovanyDokSpis) {
                    typPodani = Interface.ModFormuPodaniEnum.OpravaPodani;
                }

                const params = {
                    Ixp: Ixp,
                    ModFormu: typPodani,
                    //IDZpravy: opt.IDZpravy ? opt.IDZpravy : undefined,
                    TypPid: TypPid,
                    DataPosty: DataPosty
                };
                Gordic.Pod.Dialogs.PodaniOpravaPisemnostiDlg(content, params, undefined).done(function (ret: any) {
                    if (ret != null && ret.textInformace != null) {
                        //content.showFlash(ret.textInformace, "success", "InfoZOpravyDokumentu");
                        content.dialogs.messageBox("", ret.textInformace).on("closed", function (ev, retValClosed) {
                            Gordic.Pod.Utils.TiskPodacihoRazitka(ret.tiskPodacihoRazitka, content, Ixp).done(function () {
                                if (ret != null && ret.automatickyUzavreno) { // pokud uzavřeno uložením nabídnu dálší
                                    NoveCiziPodani(content, automat, DataPosty);
                                }
                            });

                            
                        });
                    } else {
                        if (ret != null && ret.automatickyUzavreno) { // pokud uzavřeno uložením nabídnu dálší
                            Gordic.Pod.Utils.TiskPodacihoRazitka(ret.tiskPodacihoRazitka, content, Ixp).done(function () {
                                NoveCiziPodani(content, automat, DataPosty);
                            });
                        }
                    }
                });
            }
        }
    }

    export function TiskPodacihoRazitka(tiskPodacihoRazitka: boolean, conent: GContent, PIDDokumentu: string ): JQuery.Promise < void> {
        let promis = $.Deferred();
        if (tiskPodacihoRazitka) {
          
            var tiskAkce = GAction.createPrintAction({ // conent.actions.add(GAction.createPrintAction({
                name: "actTiskPodacihoRazitka",
                caption: "Tisk podaciho razitka", //RC 31950215 : Tisk průvodky
                tooltip: "Tisk podacího razítka", //RC 31950215 : Tisk průvodky
                tema: "ssl_ptm_doktisk",
                visible: false,
                reportStarting: function (rep) {
                    rep.params.X0000 = PIDDokumentu;
                    //rep.params.X0009 = Gordic.Report.Client.GReportX0009.GetDefault(UserProcess);
                    rep.params.IXP = PIDDokumentu;
                },
                //reportFinished: function (rep) {
                //    ;
                //    //promis.resolve();
                //},
                dialogClosed: function (rep) {
                    promis.resolve();
                }
            });
            
            //conent.actions.actTiskPodacihoRazitka.run();
            tiskAkce.run();

        } else {
            promis.resolve();
        }
        return promis.promise();
    }


    export function JdeOZasilkuInternihoVypraveni(content: GContent, ListZasilekDto?: Gordic.Wfl.Interface.GZasilkaDto[] | null ): boolean {
        var ret = false;
        if (ListZasilekDto && ListZasilekDto.length > 0) {
            ret = true;
            if (ListZasilekDto.length > 1) {
                //VyberZasilkyListDlg
                
                var opt = {
                    Data: ListZasilekDto
                };
                var promisDat = Gordic.Wfl.Dialogs.VyberZasilkyListDlg(content, opt);
              
                promisDat.then(function (sxs) {
                    if (sxs) {
                        
                        var GSxs: Wfl.Interface.GSxs = {};
                        GSxs.Sxs = sxs;
                        /*
                        var ixpSxs: string;
                        var licSxs: string;
                        var porCislo: number;
                        GSxs.Ixp = sxs.substr(0, 12);
                        GSxs.Lic = sxs.substr(12, 4);
                        GSxs.PorCislo = parseInt(sxs.substr(16));
                        */

                        ZpracujZasilkuInternihoVypraveni(content, GSxs);                
                    }
                    //GWflCommon.ShowTab(l_oTab, null, Properties.Resources.Icons__Wfl__e_dokument_v_nearchivnim_formatu);
                });

            }
            if (ListZasilekDto.length == 1) {

                var l_sxs: Wfl.Interface.GSxs = { Ixp: ListZasilekDto[0].ixp, Lic: ListZasilekDto[0].lic, PorCislo: ListZasilekDto[0].por_cislo };
                ZpracujZasilkuInternihoVypraveni(content, l_sxs);
            }
        }

        return ret;
    }


    export function ZpracujZasilkuInternihoVypraveni(content: GContent, Sxs: Wfl.Interface.GSxs): void {
        //debu
        var options = {
            TypDok: Gordic.Wfl.Globals.Enums.TypDok.Cizi,
            TypId: Gordic.Wfl.Globals.Enums.TypId.IXP, //  asi přepnout na ixs
            Title: "jres:31950307" //RC 31950307 : Zadejte ID dokumentu pro interní vypravení
        };
     
        Gordic.Wfl.Dialogs.GenerovaniIxp(null, options, Gordic.Global.Enums.ModOtevreni.showModalWindow).done(function (retVal) {
            if (retVal && retVal.Ixp) {
                var srv = GetSrv();
                
                var optZpracujInterniVypraveni = {
                    Sxs: Sxs.Sxs ? Sxs.Sxs :null,
                    Ixp: Sxs.Ixp ? Sxs.Ixp : null,
                    Lic: Sxs.Lic ? Sxs.Lic : null,
                    PorCislo: Sxs.PorCislo ? Sxs.PorCislo : null,
                    IxpNew: retVal.Ixp
                }
                //debu
                srv.call<WebControls.RetZpracujInterniVypraveni>("ZpracujInterniVypraveni", optZpracujInterniVypraveni)
                    .then(function (retValZpracujInterniVypraveni) {
                        //debu
                        const paramsOprava = {
                            Ixp: retValZpracujInterniVypraveni.IxpNew,
                            ModFormu: Interface.ModFormuPodaniEnum.OpravaPoPodaniInternihoVypraveni,
                            //IDZpravy: opt.IDZpravy ? opt.IDZpravy : undefined,
                            TypPid: Gordic.Wfl.Interface.TypPid.jizEvidovanyDokSpis,
                            PredplneniPrideleni: retValZpracujInterniVypraveni.Prideleni
                        };


                        Gordic.Pod.Dialogs.PodaniOpravaPisemnostiDlg(content, paramsOprava, undefined);

                    });
            }
        });

    }

    function VyhodInformaceHlasku(content: GContent, text: string): JQuery.Promise<any> {
        if (text) {
            return content.dialogs.messageBox(
                "jres:31950292", //RC 31950292 : Upozornění
                text
            )
                .createDialogPromise();
        } else {
            return $.Deferred().resolve().promise();
        }
    }

    function VyhodnotOtazkuKdyzJe(content: GContent, text: string): JQuery.Promise<string> {
    
        var retProm = $.Deferred<string>();
        if (text) {
            content.dialogs.confirm(
                'jres:23900131', //RC 23900131 : Tisk předané došlé pošty
                text
            )
                .createDialogPromise()
                .then((retVal) => {
                    if (retVal !== 'yes') {
                        retProm.resolve("no");
                    } else {
                        retProm.resolve("yes");

                    }

                });
        } else {
            retProm.resolve("no");
        }
        return retProm.promise();
    }

}
